import React from "react";

interface HtmlContentProps {
    content: string;
    className?: string;
    emptyMessage?: string;
}


export const HtmlContent: React.FC<HtmlContentProps> = ({
                                                            content,
                                                            className = "font-sans text-slate-700",
                                                            emptyMessage = "No content available"
                                                        }) => {
    if (!content) {
        return <p className="text-slate-500 italic">{emptyMessage}</p>;
    }

    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{ __html: content }}
        />
    );
};